import React, { useState } from 'react'

import { VscChevronDown, VscChevronUp } from 'react-icons/vsc'
import { useNavigate } from 'react-router-dom'

import { Button, SectionSubtitle } from '../..'
import { useUser } from '../../../context'
import { questions } from '../../../pages/InitialFormPage/QuestionsSection'
import { QuestionWithAnswers } from '../../../pages/InitialFormPage/styles'
import { capitalizeFirstLetter } from '../../../utilFunctions/transformFunc'
import {
  FormResponsesSectionContainer,
  CollapsableContainer,
  CollapsableTitle,
  CollapsableContent,
} from '../styles'

const FormResponsesSection = ({
  hasForm,
  form,
}: {
  hasForm: boolean
  form?: { [key: string]: string }
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const navigate = useNavigate()
  const { user, onEditionMode } = useUser()

  return (
    <FormResponsesSectionContainer>
      <CollapsableContainer>
        <CollapsableTitle
          $hasForm={hasForm}
          onClick={hasForm ? () => setIsCollapsed(!isCollapsed) : undefined}
        >
          <SectionSubtitle
            fontWeight={500}
            fontSize={16}
            lineHeight={21}
            className="questionare-title"
          >
            <div className="title-btn-container">
              <div>
                Cuestionario:{' '}
                <span
                  style={{
                    color: hasForm ? '#08A8D2' : '#0A0A18',
                  }}
                >
                  {hasForm ? 'Realizado' : 'Incompleto'}
                </span>
              </div>
              {!hasForm && user && user.role === 'student' && onEditionMode && (
                <Button
                  className="light-blue"
                  label="Completar"
                  onClick={() =>
                    navigate('/initial-form', {
                      state: {
                        userId: user.uid,
                      },
                    })
                  }
                />
              )}
            </div>
          </SectionSubtitle>
          {hasForm && (
            <div onClick={() => setIsCollapsed(!isCollapsed)}>
              <p>
                Ver respuestas{' '}
                {isCollapsed ? <VscChevronUp /> : <VscChevronDown />}
              </p>
            </div>
          )}
        </CollapsableTitle>
        <CollapsableContent $isCollapsed={isCollapsed}>
          <div>
            {form &&
              Object.entries(form).map(([key, value]) => (
                <QuestionWithAnswers key={key}>
                  <p className="number">{key}</p>
                  <p className="question">
                    {questions.find((question) => question.id === key)?.text}
                  </p>

                  <p className="response">{capitalizeFirstLetter(value)}</p>
                </QuestionWithAnswers>
              ))}
          </div>
        </CollapsableContent>
      </CollapsableContainer>
    </FormResponsesSectionContainer>
  )
}

export default FormResponsesSection
